import { render, staticRenderFns } from "./Rss.vue?vue&type=template&id=7c45b6a4&"
import script from "./Rss.vue?vue&type=script&lang=js&"
export * from "./Rss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports